// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-8ca1c38e]{width:100%;height:auto}.wechat[data-v-8ca1c38e]{width:1.333333rem;height:1.333333rem;border-radius:50%;background:#adff2f;margin:0 auto;margin-top:5.333333rem}", ""]);
// Exports
module.exports = exports;
